import * as yup from 'yup';
import { InferType } from 'yup';
import { TradeSide } from '../schema';

export enum FixedIncomeTradeFormKeys {
  SIDE = 'side',
  LIMIT_PRICE = 'limitPrice',
  AMOUNT = 'amount',
}

export const fixedIncomeTradeSchema = yup.object({
  [FixedIncomeTradeFormKeys.SIDE]: yup
    .mixed<TradeSide>()
    .oneOf([TradeSide.BUY, TradeSide.SELL])
    .required(),
  [FixedIncomeTradeFormKeys.LIMIT_PRICE]: yup.number().moreThan(0).required(),
  [FixedIncomeTradeFormKeys.AMOUNT]: yup.number().min(1).required(),
});

export type FixedIncomeTradeFormValues = InferType<typeof fixedIncomeTradeSchema>;
